import { themeBase, type AppThemeConfig } from '../revoo/themeBase';

/**
 * Chiavi passate ai partial in themes/shared/* (Input, Button, …).
 *
 * Per aggiungere un tema in futuro:
 * 1. Crea `themes/<nome>/themeBase.ts` e `<nome>Theme.ts` (extendTheme come revoo).
 * 2. Importa il themeBase qui e aggiungilo alla mappa `themes`.
 * 3. Aggiungi un valore a `ThemesKeys` e usa quella chiave in `<nome>Theme.ts`.
 */
export enum ThemesKeys {
  themeRevoo = 'theme:revoo',
}

const themes: Record<string, AppThemeConfig> = {
  default: themeBase as AppThemeConfig,
  [ThemesKeys.themeRevoo]: themeBase as AppThemeConfig,
};

const getThemes = (theme?: ThemesKeys): AppThemeConfig => {
  const search =
    typeof window !== 'undefined' ? location?.search?.substring(1) || '' : '';

  let parsedGlobals: string | undefined;
  try {
    const parse = search
      ? JSON.parse(
          '{"' +
            decodeURI(search)
              .replace(/"/g, '\\"')
              .replace(/&/g, '","')
              .replace(/=/g, '":"') +
            '"}',
        )
      : '';
    parsedGlobals = parse?.globals;
  } catch {
    parsedGlobals = undefined;
  }

  const key = (theme || parsedGlobals || 'default') as string;
  return themes[key] ?? themeBase as AppThemeConfig;
};

export default getThemes;
